class Events {
    static DQ = 'DQ';
    static DNF = 'DNF';
    static FOUL = 'FOUL';
    static PASS = 'PASS';
    static NH = 'NH';
    static SEED_TIME = 99999;
    static SEED_NO_TIME = -1;
    static SEED_UNAVAILABLE = -2;

    static R50m = '50m';
    static R50h = '50H';
    static R55m = '55m';
    static R55h = '55H';
    static R60m = '60m';
    static R60h = '60H';
    static R100m = '100m';
    static R100h = '100H';
    static R110h = '110H';
    static R200m = '200m';
    static R200h = '200H';
    static R300m = '300m';
    static R300h = '300H';
    static R400m = '400m';
    static R400h = '400H';
    static R500m = '500m';
    static R600m = '600m';
    static R800m = '800m';
    static R1000m = '1000m';
    static R1200m = '1200m';
    static R1500m = '1500m';
    static R1600m = '1600m';
    static R1Mile = '1 Mile';
    static R2000mSteeplechase = '2000m Steeplechase';
    static R3000m = '3000m';
    static R3000mSteeplechase = '3000m Steeplechase';
    static R3200m = '3200m';
    static R2Mile = '2 Mile';
    static R5000m = '5000m';
    static R10000m = '10000m';
    static W1500m = '1500m Walk';
    static W1600m = '1600m Walk';
    static W3000m = '3000m Walk';
    static W5000m = '5000m Walk';
    static HighJump = 'High Jump';
    static PoleVault = 'Pole Vault';
    static TripleJump = 'Triple Jump';
    static LongJump = 'Long Jump';
    static ShotPut = 'Shot Put';
    static Discus = 'Discus';
    static Hammer = 'Hammer';
    static Weight = 'Weight';
    static Javelin = 'Javelin';
    static R4x100m = '4x100m';
    static R4x200m = '4x200m';
    static R4x400m = '4x400m';
    static R4x800m = '4x800m';
    static R4x1500m = '4x1500m';
    static R4x1600m = '4x1600m';
    static SMR800m = '800m Medley Relay';
    static SMR1600m = '1600m Medley Relay';
    static Swedish = 'Swedish Medley Relay';
    static DMR = 'Distance Medley Relay';
    static SHR4x55h = '4x55H';
    static SHR4x60h = '4x60H';
    static SHR4x100h = '4x100H';
    static SHR4x110h = '4x110H';
    static Pentathlon = 'Pentathlon';
    static Heptathlon = 'Heptathlon';
    static Decathlon = 'Decathlon';
    static PentathlonIndoor = 'Pentathlon (Indoor)';
    static PentathlonOutdoor = 'Pentathlon (Outdoor)';
    static Running = 'Running';
    static Walking = 'Walking';
    static Field = 'Field';
    static Relay = 'Relay';
    static Multi = 'Multi Events';
    static Distance = 'Distance';
    static Height = 'Height';
    static Points = 'Points';
    static Time = 'Time';

    static EventTypes = [this.Running, this.Walking, this.Field, this.Relay, this.Multi];
    static ResultTypes = [this.Distance, this.Height, this.Points, this.Time];
    static RunningEvents = [
        this.R50m,
        this.R50h,
        this.R55m,
        this.R55h,
        this.R60m,
        this.R60h,
        this.R100m,
        this.R100h,
        this.R110h,
        this.R200m,
        this.R200h,
        this.R300m,
        this.R300h,
        this.R400m,
        this.R400h,
        this.R500m,
        this.R600m,
        this.R800m,
        this.R1000m,
        this.R1200m,
        this.R1500m,
        this.R1600m,
        this.R1Mile,
        this.R2000mSteeplechase,
        this.R3000m,
        this.R3000mSteeplechase,
        this.R3200m,
        this.R2Mile,
        this.R5000m,
        this.R10000m,
        this.W1500m,
        this.W1600m,
        this.W3000m,
        this.W5000m,
    ];
    static WalkEvents = [this.W1500m, this.W1600m, this.W3000m, this.W5000m];
    static FieldEvents = [this.PoleVault, this.HighJump, this.LongJump, this.TripleJump, this.ShotPut, this.Discus, this.Hammer, this.Weight, this.Javelin];
    static RelayEvents = [
        this.R4x100m,
        this.R4x200m,
        this.R4x400m,
        this.R4x800m,
        this.R4x1500m,
        this.R4x1600m,
        this.SMR800m,
        this.SMR1600m,
        this.Swedish,
        this.DMR,
        this.SHR4x55h,
        this.SHR4x60h,
        this.SHR4x100h,
        this.SHR4x110h,
    ];
    static MultiEvents = [this.Pentathlon, this.Heptathlon, this.Decathlon];
    static TimedEvents = this.RunningEvents.concat(this.WalkEvents).concat(this.RelayEvents);
    static VerticalEvents = [this.PoleVault, this.HighJump];
    static HorizontalEvents = [this.LongJump, this.TripleJump, this.ShotPut, this.Discus, this.Hammer, this.Weight, this.Javelin];
    static PointEvents = [this.Pentathlon, this.Heptathlon, this.Decathlon, this.PentathlonIndoor, this.PentathlonOutdoor];
    static QuarterInchEvents = [this.PoleVault, this.HighJump, this.LongJump, this.TripleJump, this.ShotPut, this.Weight];
    static TrialFinalEvents = [
        this.R50m,
        this.R50h,
        this.R55m,
        this.R55h,
        this.R60m,
        this.R60h,
        this.R100m,
        this.R100h,
        this.R110h,
        this.R200m,
        this.R200h,
        this.R300m,
        this.R300h,
        this.R400m,
        this.R400h,
        this.R500m,
        this.R4x100m,
        this.R4x200m,
        this.R4x400m,
    ];
    static SplitEvents = [
        this.R600m,
        this.R800m,
        this.R1000m,
        this.R1500m,
        this.R1600m,
        this.R1Mile,
        this.R2000mSteeplechase,
        this.R3000m,
        this.R3000mSteeplechase,
        this.R3200m,
        this.R2Mile,
        this.R5000m,
        this.R10000m,
        this.W1500m,
        this.W1600m,
        this.W3000m,
        this.W5000m,
    ];
    static AllEvents = this.RunningEvents.concat(this.WalkEvents)
        .concat(this.RelayEvents)
        .concat(this.FieldEvents)
        .concat([this.Pentathlon, this.PentathlonIndoor, this.PentathlonOutdoor, this.Heptathlon, this.Decathlon]);
    static EventsTimedInSeconds = [
        this.R50m,
        this.R55m,
        this.R50h,
        this.R55h,
        this.R60m,
        this.R60h,
        this.R100m,
        this.R100h,
        this.R110h,
        this.R200m,
        this.R200h,
        this.R300m,
        this.R300h,
        this.R400m,
        this.R400h,
        this.R500m,
        this.R4x100m,
        this.SHR4x55h,
        this.SHR4x60h,
        this.SHR4x100h,
        this.SHR4x110h,
    ];
    static MedleyRelays = [this.SMR800m, this.SMR1600m, this.Swedish, this.DMR];

    static SortByName = (e1, e2) => {
        const index1 = this.AllEvents.indexOf(e1.name);
        const index2 = this.AllEvents.indexOf(e2.name);
        if (index1 == -1 && index2 == -1) {
            return e1.displayName().localeCompare(e2.displayName());
        }
        return index1 - index2;
    };

    static SortByName2 = (e1, e2) => {
        const index1 = this.AllEvents.indexOf(e1);
        const index2 = this.AllEvents.indexOf(e2);
        if (index1 == -1 && index2 == -1) {
            return e1.localeCompare(e2);
        }
        return index1 - index2;
    };

    static SortByOrder = (e1, e2) => {
        return e1.order - e2.order;
    };

    static SortResultByName = (r1, r2) => {
        const name1 = r1.meet.course ? `${r1.meet.course} ${r1.name}` : r1.name;
        const name2 = r2.meet.course ? `${r2.meet.course} ${r2.name}` : r2.name;
        if (r1.meet.course && r2.meet.course) {
            return name1.localeCompare(name2);
        }
        const index1 = this.AllEvents.indexOf(name1);
        const index2 = this.AllEvents.indexOf(name2);
        return index1 - index2;
    };

    static SortResultBySeed(event) {
        const isTimed = Events.isTimedEvent(event);
        return function (e1, e2) {
            var seed1 = e1.seed;
            var seed2 = e2.seed;

            if (!seed1) {
                seed1 = isTimed ? 100000 : -1;
            }
            if (!seed2) {
                seed2 = isTimed ? 100000 : -1;
            }

            if (seed1 == seed2) {
                if (Events.isRelayEvent(event)) {
                    if (e1.team && e2.team) {
                        return e1.team.localeCompare(e2.team);
                    }
                }

                const a1 = e1.athlete;
                const a2 = e2.athlete;
                if (a1 && a2) {
                    return a1.lastNameFirstName().localeCompare(a2.lastNameFirstName());
                }
            } else {
                return isTimed ? seed1 - seed2 : seed2 - seed1;
            }
        };
    }

    static SortResultByDate = (r1, r2) => {
        return r1.meet.dateTime - r2.meet.dateTime;
    };

    static isRelayEvent(event) {
        return this.RelayEvents.includes(event);
    }

    static isTimedEvent(event) {
        return this.TimedEvents.includes(event) || event.includes('Run');
    }

    static isEventTimedInSeconds(event) {
        return this.EventsTimedInSeconds.includes(event);
    }

    static isFieldEvent(event) {
        return this.FieldEvents.includes(event);
    }

    static isMultiEvent(event) {
        return this.PointEvents.includes(event);
    }

    static isVerticalEvent(event) {
        return this.VerticalEvents.includes(event);
    }

    static isHorizontalEvent(event) {
        return this.HorizontalEvents.includes(event);
    }

    static isTrialFinalEvent(event) {
        return this.TrialFinalEvents.includes(event);
    }

    static isSplitEvent(event) {
        return this.SplitEvents.includes(event);
    }

    static isPointEvent(event) {
        return this.PointEvents.includes(event);
    }

    static isQuarterInchEvent(event) {
        return this.QuarterInchEvents.includes(event);
    }

    static isMedleyRelay(event) {
        return this.MedleyRelays.includes(event);
    }

    static pentathlonEvents(isIndoor, isMale, isOpen) {
        if (isIndoor) {
            if (isMale) {
                return [this.R60h, this.LongJump, this.ShotPut, this.HighJump, this.R1000m];
            } else {
                return [this.R60h, this.HighJump, this.ShotPut, this.LongJump, this.R800m];
            }
        } else {
            if (isMale) {
                if (isOpen) {
                    return [this.LongJump, this.Javelin, this.R200m, this.Discus, this.R1500m];
                } else {
                    return [this.R110h, this.ShotPut, this.HighJump, this.LongJump, this.R1500m];
                }
            } else {
                return [this.R100h, this.ShotPut, this.HighJump, this.LongJump, this.R800m];
            }
        }
    }

    static heptathlonEvents(isMale) {
        if (isMale) {
            return [this.R60m, this.LongJump, this.ShotPut, this.HighJump, this.R60h, this.PoleVault, this.R1000m];
        } else {
            return [this.R100h, this.HighJump, this.ShotPut, this.R200m, this.LongJump, this.Javelin, this.R800m];
        }
    }

    static decathlonEvents(isMale) {
        if (isMale) {
            return [this.R100m, this.LongJump, this.ShotPut, this.HighJump, this.R400m, this.R110h, this.Discus, this.PoleVault, this.Javelin, this.R1500m];
        } else {
            return [this.R100m, this.Discus, this.PoleVault, this.Javelin, this.R400m, this.R100h, this.LongJump, this.ShotPut, this.HighJump, this.R1500m];
        }
    }

    static eventsOfMulti(multi, isIndoor, isMale, isOpen) {
        if (multi == Events.Decathlon) {
            return this.decathlonEvents(isMale);
        } else if (multi == Events.Heptathlon) {
            return this.heptathlonEvents(isMale);
        } else {
            return this.pentathlonEvents(isIndoor, isMale, isOpen);
        }
    }

    static runningEvents(isIndoor, isMale) {
        const list = [];
        if (isIndoor) {
            list.push.apply(list, [
                this.R50m,
                this.R50h,
                this.R55m,
                this.R55h,
                this.R60m,
                this.R60h,
                this.R200m,
                this.R300m,
                this.R400m,
                this.R500m,
                this.R600m,
                this.R800m,
                this.R1000m,
                this.R1500m,
                this.R1600m,
                this.R1Mile,
                this.R3000m,
                this.R3200m,
                this.R2Mile,
                this.R5000m,
                this.R10000m,
            ]);
        } else {
            list.push(this.R100m);
            list.push(isMale ? this.R110h : this.R100h);
            list.push(
                ...[
                    this.R200m,
                    this.R200h,
                    this.R300m,
                    this.R300h,
                    this.R400m,
                    this.R400h,
                    this.R500m,
                    this.R600m,
                    this.R800m,
                    this.R1000m,
                    this.R1500m,
                    this.R1600m,
                    this.R1Mile,
                    this.R2000mSteeplechase,
                    this.R3000m,
                    this.R3000mSteeplechase,
                    this.R3200m,
                    this.R2Mile,
                    this.R5000m,
                    this.R10000m,
                ],
            );
        }
        return list;
    }

    static getSplitsOfEvent(event, season) {
        const list = [];
        var totalDistance = parseInt(event.match(/\d/g).join(''));
        const inMiles = event == Events.R1Mile || event == Events.R2Mile;
        if (inMiles) {
            totalDistance *= 1609;
        }
        const lapDistance = season.isIndoor() ? 200 : 400;
        var laps = parseInt(totalDistance / lapDistance);

        if (inMiles) {
            const firstLap = `${lapDistance + (totalDistance == 1609 ? 9 : 18)}m`;
            list.push(firstLap);
            laps -= 1;
        } else {
            const firstLap = totalDistance % lapDistance;
            if (firstLap > 0) {
                list.push(`${firstLap}m`);
            }
        }
        for (var i = 0; i < laps; i++) {
            list.push(`${lapDistance}m`);
        }
        return list;
    }

    static fieldEvents(isIndoor) {
        const list = [this.PoleVault, this.HighJump, this.LongJump, this.TripleJump, this.ShotPut];
        if (isIndoor) {
            list.push(this.Weight);
        } else {
            list.push(this.Discus, this.Hammer, this.Javelin);
        }
        return list;
    }

    static relayEvents(isIndoor, isMale) {
        const list = [
            this.R4x100m,
            this.R4x200m,
            this.R4x400m,
            this.R4x800m,
            this.R4x1500m,
            this.R4x1600m,
            this.SMR800m,
            this.SMR1600m,
            this.Swedish,
            this.DMR,
        ];
        if (isIndoor) {
            list.unshift(this.SHR4x55h, this.SHR4x60h);
        } else {
            list.splice(1, 0, isMale ? this.SHR4x110h : this.SHR4x100h);
        }
        return list;
    }

    static eventsOfRelay(event) {
        switch (event) {
            case this.SHR4x55h:
                return [this.R55h, this.R55h, this.R55h, this.R55h];
            case this.SHR4x60h:
                return [this.R60h, this.R60h, this.R60h, this.R60h];
            case this.R4x100m:
                return [this.R100m, this.R100m, this.R100m, this.R100m];
            case this.SHR4x100h:
                return [this.R100h, this.R100h, this.R100h, this.R100h];
            case this.SHR4x110h:
                return [this.R110h, this.R110h, this.R110h, this.R110h];
            case this.R4x200m:
                return [this.R200m, this.R200m, this.R200m, this.R200m];
            case this.R4x400m:
                return [this.R400m, this.R400m, this.R400m, this.R400m];
            case this.R4x800m:
                return [this.R800m, this.R800m, this.R800m, this.R800m];
            case this.R4x1500m:
                return [this.R1500m, this.R1500m, this.R1500m, this.R1500m];
            case this.R4x1600m:
                return [this.R1600m, this.R1600m, this.R1600m, this.R1600m];
            case this.SMR800m:
                return [this.R100m, this.R100m, this.R200m, this.R400m];
            case this.SMR1600m:
                return [this.R200m, this.R200m, this.R400m, this.R800m];
            case this.Swedish:
                return [this.R100m, this.R200m, this.R300m, this.R400m];
            case this.DMR:
                return [this.R1200m, this.R400m, this.R800m, this.R1600m];
        }
    }

    static multiEvents(isIndoor, isMale) {
        const list = [this.Pentathlon];
        if (isIndoor) {
            if (isMale) {
                list.push(this.Heptathlon);
            }
        } else {
            if (!isMale) {
                list.push(this.Heptathlon);
            }
            list.push(this.Decathlon);
        }
        return list;
    }

    static multiName(event, isIndoor) {
        if (event.includes('Pent')) {
            return isIndoor ? this.PentathlonIndoor : this.PentathlonOutdoor;
        }
        return event;
    }

    static events(isIndoor, isMale) {
        const map = new Map();
        map.set('running', this.runningEvents(isIndoor, isMale));
        map.set('walking', this.WalkEvents);
        map.set('field', this.fieldEvents(isIndoor));
        map.set('relay', this.relayEvents(isIndoor, isMale));
        map.set('multi event', this.multiEvents(isIndoor, isMale));
        return map;
    }

    static allEvents(isIndoor, isMale) {
        const events = [];
        [...this.events(isIndoor, isMale).values()].forEach((array) => {
            events.push(...array);
        });
        return events;
    }

    static calculatePointsForMultiEvent(event, result, isMale) {
        if (!result || this.hasNoMark(result)) {
            return 0;
        }
        var a = 0.0;
        var b = 0.0;
        var c = 0.0;

        var centimeters = true;

        switch (event) {
            case this.R60m:
                a = 58.015;
                b = 11.5;
                c = 1.81;
                break;
            case this.R60h:
                a = isMale ? 20.5173 : 20.0479;
                b = isMale ? 15.5 : 17.0;
                c = isMale ? 1.92 : 1.835;
                break;
            case this.R100m:
                a = isMale ? 25.4347 : 17.857;
                b = isMale ? 18.0 : 21.05;
                c = 1.81;
                break;
            case this.R100h:
                a = 9.23076;
                b = 26.7;
                c = 1.835;
                break;
            case this.R110h:
                a = 5.74352;
                b = 28.5;
                c = 1.92;
                break;
            case this.R200m:
                a = isMale ? 5.8425 : 4.99087;
                b = isMale ? 38.0 : 42.5;
                c = 1.81;
                break;
            case this.R400m:
                a = isMale ? 1.53775 : 1.34285;
                b = isMale ? 82.0 : 91.7;
                c = 1.81;
                break;
            case this.R800m:
                a = 0.11193;
                b = 254.0;
                c = 1.88;
                break;
            case this.R1000m:
                a = 0.08713;
                b = 305.5;
                c = 1.85;
                break;
            case this.R1500m:
                a = isMale ? 0.03768 : 0.02883;
                b = isMale ? 480.0 : 535.0;
                c = isMale ? 1.85 : 1.88;
                break;
            case this.LongJump:
                a = isMale ? 0.14354 : 0.188807;
                b = isMale ? 220.0 : 210.0;
                c = isMale ? 1.4 : 1.41;
                break;
            case this.HighJump:
                a = isMale ? 0.8465 : 1.84523;
                b = 75.0;
                c = isMale ? 1.42 : 1.348;
                break;
            case this.PoleVault:
                a = isMale ? 0.2797 : 0.44125;
                b = 100.0;
                c = 1.35;
                break;
            case this.ShotPut:
                a = isMale ? 51.39 : 56.0211;
                b = 1.5;
                c = 1.05;
                centimeters = false;
                break;
            case this.Discus:
                a = isMale ? 12.91 : 12.3311;
                b = isMale ? 4.0 : 3.0;
                c = 1.1;
                centimeters = false;
                break;
            case this.Javelin:
                a = isMale ? 10.14 : 15.9803;
                b = isMale ? 7.0 : 3.58;
                c = isMale ? 1.08 : 1.04;
                centimeters = false;
                break;
        }
        if (this.isTimedEvent(event)) {
            const T = this.timeToSeconds(result, 2);
            return parseInt(a * Math.pow(b - T, c));
        } else {
            var D = Number(result);
            if (centimeters) {
                D *= 100;
            }
            return parseInt(a * Math.pow(D - b, c));
        }
    }

    static resultType(event) {
        if (Events.isVerticalEvent(event)) {
            return Events.Height;
        } else if (Events.isHorizontalEvent(event)) {
            return Events.Distance;
        } else if (Events.isMultiEvent(event)) {
            return Events.Points;
        } else {
            return Events.Time;
        }
    }

    static hasNoMark = (result) => {
        return [Events.DQ, Events.DNF, Events.FOUL, Events.PASS, Events.NH].includes(result);
    };

    static timeToSeconds = (time, decimalPlaces = 3) => {
        var minutes = 0;
        var seconds;
        var multiplier = Math.pow(10, decimalPlaces);
        if (time.includes(':')) {
            const split = time.split(':');
            minutes = parseInt(split[0]);
            seconds = parseFloat(split[1]);
        } else {
            seconds = parseFloat(time);
        }
        return Math.round((seconds + minutes * 60) * multiplier) / multiplier;
    };
}

export default Events;
